<template>
  <div class="more-info">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="more-info-content">
            <div class="row">
              <div class="col-md-6">
                <div class="left-image">
                  <img src="../assets/more-info.jpg" alt="" />
                </div>
              </div>
              <div class="col-md-6 align-self-center">
                <div class="right-content">
                  <span>Who we are</span>
                  <h2>Get to know about <em>our company</em></h2>
                  <p>
                    DTECH - Tech Direct Solutions LLP a Business Consulting
                    Company registered with SECP having its directors coming
                    from Telecoms Media & Technology. Together we bring in
                    cumulative experience of Telecoms & ICT sales, ICT Solution
                    Sales, Fixed Network FTTH design, implementation Sales,
                    Satellite Solutions Broadcast & Digital Media.
                  </p>
                  <router-link to="/about" class="filled-button">Read More</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MoreInfoCard",
};
</script>
